module.exports = __webpack_public_path__ + "static/media/create_sample_group.4d71e3cf.png";